import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelect from 'UIComponents/input/UISelect';
import virtualizedMenuRenderer from 'UIComponents/input/utils/virtualizedMenuRenderer';
import SavableFormLabel from './SavableFormLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function filterOptions(options, input) {
  const regex = new RegExp(`(?=.*${input.trim().replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&').split(/\s+/).join(')(?=.*')})`, 'gi');
  return options.filter(option => regex.test(option.text));
}

// @ts-expect-error ts-migrate(2565) FIXME: Property 'defaultProps' is used before being assig... Remove this comment to see the full error message

function SavableDropdownField(props) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SavableFormLabel, {
      "data-test-id": "savable-label-test-id"
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'undefined... Remove this comment to see the full error message
      ,
      htmlFor: props.labelLangPath,
      isRequired: props.isRequired,
      isSaving: props.isSaving,
      labelLangPath: props.labelLangPath
    }), /*#__PURE__*/_jsx(UISelect, {
      id: props.labelLangPath,
      "data-test-id": "select-test-id",
      disabled: props.isDisabled || props.isSaving,
      filterOptions: filterOptions,
      menuRenderer: virtualizedMenuRenderer,
      menuWidth: 416,
      onChange: ({
        target: {
          value
        }
      }) => {
        props.onOptionSelected(value);
      },
      options: props.options,
      placement: "bottom left",
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: props.placeholderLangPath
      }),
      value: props.value ? props.value : undefined
    })]
  });
}
SavableDropdownField.propTypes = {
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  isSaving: PropTypes.bool,
  labelLangPath: PropTypes.string.isRequired,
  onOptionSelected: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  placeholderLangPath: PropTypes.string.isRequired,
  value: PropTypes.number
};
SavableDropdownField.defaultProps = {
  isDisabled: false,
  isRequired: false,
  isSaving: false
};
export default SavableDropdownField;